import React from 'react'
import { FiPlay } from 'react-icons/fi'
import { motion } from 'framer-motion'
import NavbarMegamenu from '../@shared/navigations/megamenu'
import { advantages, coreFeatures, drawersScreens, examples, faq, formScreens, headers, homeScreens, landingScreens, nextScreens, uiScreens, socialScreens, socialPages } from './mock'
import { Toolbox } from '../@shared/toolbar'

const Demo = () => {

    return (
        <div className='demo screens'>
            <title>Nova React Template</title>
           {/** <Toolbox /> */}
            <div className=''>
                <NavbarMegamenu />
                <HeroGradient />
            </div>
            <div>
           </div>
            <Advantages />
            <Showcase data={examples} title='Examples' />
            <CoreFeatures />
            <div className="headers">
             <h1 className='title'>Headers</h1>
             <ul className='header'>
                {headers.map((item,i)=>(
                    <li key={`header-${i}`} className='flex'>
                        <div className='cover'>
                            <a href={item?.path} target="_blank" rel="noreferrer" >
                                <img src={`/assets/images/screens/${item.index}.png`} alt=""/>    
                            </a>
                        </div>
                        <div className="detail flex">
                            <h3>{item.name}</h3>
                        </div>
                    </li>
                 ))}
             </ul>
           </div>
            <Showcase data={socialScreens} title='Social Media Kits' opts={{ high:true, h500:true, path:true }} />
            <Showcase data={socialPages} title='Social Media' opts={{ path:true, }} />
            <Showcase data={landingScreens} title='Landing Pages' opts={{ high:true, h500:true, path:true, party:'blueparty',contain:true }} />
            <Showcase data={nextScreens} title='Coming Soon' opts={{ high:true, path:true, grid2:true, party:'colorparty', }} />
            <Showcase data={formScreens} title='Form Pages' opts={{ path:true, party:'sunrise' }} />
            <Showcase data={uiScreens} title='Amazing Pages' opts={{ path:true, high:true, contain:true,h500:true, grid2:true, party:'colorparty', }} />
            <Showcase data={drawersScreens} title='Drawers' opts={{ path:true, party:'sunrise' }} />
            <Showcase data={homeScreens} title='Home Pages' opts={{ path:true, party:'sunrise' }} />
           <Comingsoon />
           {/* <Toolbox /> */}
        </div>
    )
}

export default Demo;

export const HeroGradient = () =>{

    return (
        <div className='hero-gradient'>
            <div className='hero centerize '>
                <div className="heading-one flex">
                    <div className='slider flex'>
                        <div className="play" onClick={()=>{
                              // dispatch(openModal({type:'intro', values:{ w:'1028', h:'482' },
                              //  settings:{ left:'10%', right:'10%', background:'transparent', border:'none', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center' } }))
                        }}>
                            <FiPlay />
                        </div>
                        <div className="information hidden">  
                            <h3 className='title'>Demo page</h3>
                            <p className='description'> Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate nisi atque quasi natus esse hic molestias soluta veritatis. Quaerat, ipsam praesentium facere quidem pariatur saepe. Amet porro in sapiente odio. </p>
                        </div>
                        <img src="/assets/images/bg/ui.png" className="bg" alt="" />
                    </div>

                    <div className="hero-overlay">
                        <motion.div className='blue-circle' initial={{ right:'-7em', filter:'blur(150px)' }} animate={{ right:'-20em', filter:'blur(70px)' }}
                            transition={{ duration:2, repeat: Infinity, repeatType: "reverse", type: "tween", ease: [0.17, 0.67, 0.83, 0.67] }} />
                        <motion.div className='green-circle' initial={{ left:'-1em', top:'15em', filter:'blur(50px)' }} animate={{ left:'-2em', top:'5em', filter:'blur(110px)' }}
                            transition={{ duration:2, repeat: Infinity, repeatType: "reverse", type: "tween", ease: [0.17, 0.67, 0.83, 0.67] }} />
                         <motion.div className='pink-circle' initial={{ left:'21em', top:'15em', filter:'blur(110px)'}} animate={{ left:'25em', top:'20em', filter:'blur(50px)'}}
                            transition={{ duration:2, repeat: Infinity, repeatType: "reverse", type: "tween", ease: [0.17, 0.67, 0.83, 0.67]  }} />
                    </div>
            </div>
           </div>
        </div>
    )
}

const Advantages = () => {
    return (
        <div className='advantages'>
            <h1 className='big-title'>+100</h1>
            <h3 className='title'>Rich Components</h3>
            <p className='description'>There is have many advantages. Customize easily your site within advanced multipurpose components. <br />  More demos are coming soon.</p>
            <ul>
                {advantages?.map((item,i)=>(
                    <li key={`advantage-${i}`}>
                        <div className="image" ><img src={`/assets/images/demo/${item.img}.png`} alt={item.title} /></div>
                        <p>{item.title}</p>
                    </li>
                ))}
            </ul>
        </div>
    )
}
const CoreFeatures = () => {
    return (
        <div className='core-features'>
            <h1 className='big-title'>Core Features</h1>
           <div className='wrapper'>
            <ul>
                    {coreFeatures?.map((item,i)=>(
                        <li key={`core-feature-${i}`}>
                            <div className="image" title={item.title}>
                                {item.symbol ? item.symbol : <img src={`/assets/images/demo/${item.img}.png`} alt={item.title}  />}
                            </div>
                           {/**  <p>{item.title}</p> **/}
                        </li>
                    ))}
                </ul>
           </div>

        </div>
    )
}
const Comingsoon = () => {
    return (
        <div className='comingsoon'>
            <div className='image'></div>
            <div className='box'>
                <h1 className='title'>RTL & Darkmode are coming soon.</h1>
                <div className="coming-overlay- hidden">
                    <div className="circle one"></div>
                    <div className="circle two"></div>
                    <div className="circle three"></div>
                    <div className="circle four"></div>
                    <div className="circle five"></div>
                </div>
            </div>
         
        </div>
    )
}
const Banner = ({title, party='colorparty'}) =>{

    return (
    <div className={`banner ${party}`}>
        <div>
            <h1 className='title'>{title||'Examples'}</h1>
            <p className='description'>Just Nova!</p>
        </div>
        <ul className='actions flex-end'>
        {/**  <li><FiSettings size={35} /></li> **/}
        </ul>
    </div>
    )
}

const Showcase = ({data, title, opts}) => {

    return (
        <React.Fragment>
             <Banner title={title} party={` ${opts?.party? opts?.party :'colorparty'}`} />

            <ul className={`screen ${opts?.high?'high':''} ${opts?.grid2?'grid2':''} `}>
                {
                    data?.map((item,i)=>{

                            return (
                                <li key={`screen-${i}`} className='flex'>
                                    <div  className={`cover  ${!item.path?'soon':''}  ${opts?.h500?'h500':''} ${opts?.contain?'contain':''}`}>
                                        {opts?.path ?  <a href={`${item.id?item.id:'#'}`} style={{
                                        backgroundImage:`url(/assets/images/screens/${item.path}.png)`
                                    }}> </a> : <a href={item.path} style={{
                                        backgroundImage:`url(/assets/images/screens/${item.index}.png)`
                                    }}> </a> }
                                        
                                    </div>
                                    <div className="detail flex">
                                        <h3>{item.name}</h3>
                                    </div>
                                </li>
                            )
                    })
                }
            </ul>
        </React.Fragment>
    )
}